export default __webpack_public_path__ + "c36161d.png";